import { isPostHogReady, posthog } from './posthog'

type Primitive = string | number | boolean | null | undefined
export type EventParams = Record<string, Primitive>

declare global {
  interface Window {
    dataLayer?: IArguments[]
    gtag?: (...args: unknown[]) => void
  }
}

export function track(eventName: string, params: EventParams = {}): void {
  if (typeof window === 'undefined' || !eventName) return
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params)
    }
  } catch (err) {
    console.warn('analytics.track[gtag] failed', eventName, err)
  }
  try {
    if (isPostHogReady()) {
      posthog.capture(eventName, params)
    }
  } catch (err) {
    console.warn('analytics.track[posthog] failed', eventName, err)
  }
}

export function setUserId(userId: string | null): void {
  if (typeof window === 'undefined') return
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('set', { user_id: userId })
    }
  } catch (err) {
    console.warn('analytics.setUserId[gtag] failed', err)
  }
  try {
    if (isPostHogReady()) {
      if (userId) {
        posthog.identify(userId)
      } else {
        posthog.reset()
      }
    }
  } catch (err) {
    console.warn('analytics.setUserId[posthog] failed', err)
  }
}
